import { render, staticRenderFns } from "./reservoirManage.vue?vue&type=template&id=2d310e72&scoped=true"
import script from "./reservoirManage.vue?vue&type=script&lang=js"
export * from "./reservoirManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d310e72",
  null
  
)

export default component.exports